import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { map } from "rxjs/operators";
import { ApiPropertyAndLeaseConstants } from "../../constants/api-constants/api-property-and-lease.constants";
let PropertyAndLeaseService = class PropertyAndLeaseService {
    http;
    constructor(http) {
        this.http = http;
    }
    getLesseesObservable(jobId) {
        return this.http.get(`${ApiPropertyAndLeaseConstants.URL}/${jobId}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_LESSEES}?%24expand=groups`)
            .pipe(map((response) => {
            return response;
        }));
    }
    getBuyersObservable(jobId) {
        return this.http.get(`${ApiPropertyAndLeaseConstants.URL}/${jobId}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_BUYERS}?%24expand=groups`)
            .pipe(map((response) => {
            return response;
        }));
    }
    getSellersObservable(jobId) {
        return this.http.get(`${ApiPropertyAndLeaseConstants.URL}/${jobId}/${ApiPropertyAndLeaseConstants.FUNCTION_GET_SELLERS}?%24expand=groups`)
            .pipe(map((response) => {
            return response;
        }));
    }
    getApplicationSaveDetailsObservable(appId, params) {
        return this.http.post(`${ApiPropertyAndLeaseConstants.URL}/${appId}/${ApiPropertyAndLeaseConstants.FUNCTION_SET_DETAILS}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    getApplicationSavePropertiesObservable(appId, params) {
        return this.http.post(`${ApiPropertyAndLeaseConstants.URL}/${appId}/${ApiPropertyAndLeaseConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map(response => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
PropertyAndLeaseService = __decorate([
    Injectable({
        providedIn: "root"
    })
], PropertyAndLeaseService);
export { PropertyAndLeaseService };
